<!--
 * @Author: your name
 * @Date: 2020-04-15 10:40:24
 * @LastEditTime: 2020-04-15 15:29:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\components\contentcoms\newscontentcoms\news13.vue
 -->
<!--
 * @Author: your name
 * @Date: 2020-04-14 08:54:09
 * @LastEditTime: 2020-04-14 09:01:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\components\contentcoms\newscontentcoms\news12.vue
 -->
<!--
 * @Author: your name
 * @Date: 2020-04-14 08:39:13
 * @LastEditTime: 2020-04-14 08:53:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\components\contentcoms\newscontentcoms\news11.vue
 -->
<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        <p>
            大连海大智龙科技有限公司喜获第一届辽宁省专利奖一等奖
        </p>
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2020-04-15</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
     <p style="text-align:left;text-indent:20px;">
         近日，辽宁省人民政府公布了第一届辽宁省专利奖正式评审结果。在全省评出的5项一等奖中，海大智龙公司尹勇教授团队的“高品质航海模拟器及其开发平台系统”获得一等奖。
     </p>
     <p style="text-align:left;text-indent:20px;">
         “高品质航海模拟器及其开发平台系统”属于交通运输领域，同族专利26项，后续授权发明专利18项。2018年，该专利通过作价投资的方式，在大连注册成立了“大连海大智龙科技有限公司”，该公司通过了知识产权管理体系认证。该专利创造性地采用多本船体系结构，提出一种高精度的船舶六自由度运动建模方法，获得挪威船级社航海模拟A级认证，打破了西方国家对我国航海模拟器市场的垄断，国内市场占有率70%，对我国高素质航运人才培养做出巨大贡献，具有广阔的发展前景。
     </p>
     <p style="text-align:left;text-indent:30px;">
         据悉，辽宁省专利奖是辽宁省政府为深入贯彻落实习近平新时代中国特色社会主义思想，全面贯彻党的十九大和十九届二中、三中、四中全会精神，坚定实施创新驱动发展和知识产权战略，充分发挥专利制度推动科技创新的作用，激励广大人民群众和科技工作者发明创造的积极性，促进专利技术产业化和专利事业高质量发展而专门设立的政府奖。
     </p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isflag1: true,
        isflag2: false,
        isflag3: false
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (parseInt(scrollTop) >= 550 && parseInt(scrollTop) < 1200) {
          // alert(scrollTop)
          this.isflag2 = true;
        }
        if (parseInt(scrollTop) >= 1200) {
          this.isflag3 = true;
        }

      },
      destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
      },
    },
  };

</script>

<style scoped>
  img {
    margin-top: 30px;
  }

  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

  .div-padding-left {
    padding-left: 36px;
  }

  .div-top30 {
    margin-top: 30px;
  }

  .div-top0 {
    margin-bottom: 0px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news13.vue